import { Sprout, Leaf, TreeDeciduous, CircleDot, Trees } from 'lucide-react';
import type { GrowthStage } from '@/lib/types';
import { cn } from '@/lib/utils';

interface GrowthIconProps {
  stage: GrowthStage;
  className?: string;
  size?: number;
}

export function GrowthIcon({ stage, className, size = 20 }: GrowthIconProps) {
  const iconProps = {
    size,
    className: cn('text-primary', className),
  };

  switch (stage) {
    case 'seed':
      return <CircleDot {...iconProps} />;
    case 'sprout':
      return <Sprout {...iconProps} />;
    case 'plant':
      return <Leaf {...iconProps} />;
    case 'growing':
      return <TreeDeciduous {...iconProps} />;
    case 'tree':
      return <Trees {...iconProps} />;
    default:
      return <CircleDot {...iconProps} />;
  }
}
